import React from 'react';
import { useGridApiContext, GridEditInputCell } from '@mui/x-data-grid-pro';
import { useSelector } from 'react-redux';
import { selectUser } from 'oidc/user.selectors';
import { userAllowedToEdit } from '../../helper';
import { handleGridCellChange } from './changeDetectionHelper';

const GridTextInputCell = React.memo(function GridTextInputCell(props: any) {
  const { field, row, value, id } = props;
  const user = useSelector(selectUser);
  const ref = useGridApiContext();
  
  const allowEdit = React.useMemo(() => {
    return userAllowedToEdit(user?.userInfo) || row?.allowEdit;
  }, [row?.allowEdit, user?.userInfo]);

  const isEditingDisabled = () => {
    if (row?.isTimeOff && field !== 'zip') {
      return true;
    }
    if (field === 'position' || field === 'unit') {
      return !allowEdit;
    }
    return false;
  };

  // Custom onValueChange handler to detect changes immediately
  const handleValueChange = (newValue: any) => {
    // Use the helper function for change detection
    handleGridCellChange({
      id,
      field,
      newValue,
      oldValue: value,
      apiRef: ref,
    });
  };

  return (
    <GridEditInputCell 
      {...props} 
      disabled={isEditingDisabled()} 
      onValueChange={handleValueChange}
    />
  );
});

export const renderGridTextInputCell = params => {
  return <GridTextInputCell {...params} />;
};
